// project-imports
import { generateMenuList } from './menu';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

export const getMenuItems = (enabledMenuIds: Set<string>): { items: NavItemType[] } => ({
  items: [generateMenuList(enabledMenuIds)]
});
